/**
 * Issue #1030 (review F3) — where the match list keeps its sort, and what it
 * opens with. The redrawn list (`newUi("matches")`) has its OWN key and opens
 * newest first (its lede says so); the shipped page keeps `nw_perf_sort` and
 * its oldest-first default, so a stored direction from one page never
 * contradicts the other and a flag-on visit never rewrites the flag-off
 * page's sort.
 */
export const SHIPPED_SORT_KEY = "nw_perf_sort";
export const MATCHES_SORT_KEY = "nw_perf_sort_matches";

export const sortStorageKey = (matchesOn) => (matchesOn ? MATCHES_SORT_KEY : SHIPPED_SORT_KEY);

export function readStoredSort(storage, matchesOn) {
  try {
    const saved = storage.getItem(sortStorageKey(matchesOn));
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed?.key && (parsed.dir === "asc" || parsed.dir === "desc")) return parsed;
    }
  } catch { /* invalid JSON — fall through to default */ }
  return { key: "match_date", dir: matchesOn ? "desc" : "asc" };
}
